import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";

import { NotifyMeProps } from "./NotifyMeProps";

export const notifyMeProductTileAdaptor = (
  productTile: ILeanProductTile
): NotifyMeProps => {
  return {
    productToken: productTile.product?.token,
    productOptionToken: productTile?.quick_add?.quick_add_option?.option_token,
    productState: productTile?.product?.state,
  };
};
